import { GetVoiceAndToneCurrentAndTargetVectorsResponse } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentServerProxy/types';
import { ChartDataAdapter } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/Summary/Visualizations/adapters/types';

// TODO(jvancamp): define the data type that the chart will use
type ProductLevelVoiceAndToneAnalysisData = any;

export class ProductLevelVoiceAndToneAnalysisAdapter implements ChartDataAdapter<ProductLevelVoiceAndToneAnalysisData> {
  data: GetVoiceAndToneCurrentAndTargetVectorsResponse;

  constructor(data: GetVoiceAndToneCurrentAndTargetVectorsResponse) {
    this.data = data;
  }

  transform(): GetVoiceAndToneCurrentAndTargetVectorsResponse {
    return this.data;
  }
}
